import {
  Form,
  FormItem,
  Input,
  Row,
  Col,
  Tooltip,
  Button,
  Select,
  Option,
  Dialog,
} from "element-ui";
import { mapState } from "vuex";
import { omit } from "lodash";
import isMobile from "@/shared/utils/isMobile";
import { formatNumberFractionDigits } from "@/shared/utils/formatNumber.js";
import styles from "./index.less?module";

const SignalBaseInfo = {
  data() {
    return {
      formVal: {
        portfolioName: "",
        shareProfitPercent: null,
        settlementPeriodType: null,
        followDirection: "",
        createTime: "",
        currentSettlementBeginTime: "",
        currentSettlementEndTime: "",
        account: "",
        serverName: "",
        equity: null,
        balance: null,
        profit: "",
        loginStatus: null,
      },
      enableStatus: 0,
      enableControlStatus: 0,
      switchLoading: false,
      shareProfitPercentDisabled: true,
      detailInfo: {},
      settlementPeriodTypeStatus: 1,
      shareProfitPercentStatus: 1,
      isDisabledDialog: false,
      settleUnbindForm: {
        currentBeginTime: "",
        followUserCount: null,
        sharePercent: null,
        shareTotalProfit: null,
      },
      visibleReregister: false,
      reregisterFormVal: {
        account: "",
        server: "",
        password: "",
      },
      reregisterPasswordVisible: false,
    };
  },
  computed: {
    ...mapState(["checkPortfolio"]),
  },
  created() {
    this.getBaseInfo();
  },
  methods: {
    formatNumberFractionDigits,
    // 获取信号源基本信息
    getBaseInfo() {
      const loading = this.$loading({
        lock: true,
      });
      this.$axios
        .get("/api/Portfolio/GetPortfolioDetail", {
          params: { id: this.checkPortfolio.id },
        })
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.detailInfo = dt.result;
            this.formVal = omit(dt.result, [
              "settlementPeriodTypeTitle",
              "deleteBtnStatus",
              "enableControlStatus",
              "status",
              "followDirection",
            ]);
            this.enableStatus = dt.result.status;
            this.enableStatusTxt = dt.result.status ? this.$t("Common_EnabledIng") : this.$t("Common_DisabledIng");
            this.formVal.account = dt.result.mainAccountInfo.account;
            this.formVal.serverName = dt.result.mainAccountInfo.serverName;
            this.formVal.equity = dt.result.mainAccountInfo.equity;
            this.formVal.balance = dt.result.mainAccountInfo.balance;
            this.formVal.profit = formatNumberFractionDigits(
              dt.result.mainAccountInfo.profit,
              { usePlus: true }
            );
            this.formVal.loginStatus = dt.result.mainAccountInfo.loginStatus;
            this.formVal.followDirection = dt.result.followDirection
              ? this.$t("Common_TR_ReverseCopy")
              : this.$t("Common_TR_Copy");
            this.enableControlStatus = dt.result.enableControlStatus;
            this.settlementPeriodTypeStatus =
              dt.result.settlementPeriodTypeStatus;
            this.shareProfitPercentStatus = dt.result.shareProfitPercentStatus;
            this.reregisterFormVal.account = dt.result.mainAccountInfo.account;
            this.reregisterFormVal.serverName =
              dt.result.mainAccountInfo.serverName;
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    // 分润比例：编辑、保存
    handleShareProfitPercentCLick() {
      this.$refs.signalBaseInfoForm.validateField(
        "shareProfitPercent",
        (errorMessage) => {
          if (!errorMessage) {
            this.$axios
              .post("/api/Portfolio/InitShareProfitPercent", {
                id: this.checkPortfolio.id,
                shareProfitPercent: +this.formVal.shareProfitPercent,
              })
              .then((res) => {
                let dt = res.data;
                if (dt.isSuccess) {
                  this.$notify.success({
                    title: this.$t("Common_Prompt"),
                    message: this.$t("Common_OperateSuccess"),
                  });
                  this.getBaseInfo();
                } else {
                  this.$notify.error({
                    title: this.$t("Common_Prompt"),
                    message: dt.result,
                  });
                }
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        }
      );
    },
    // 结算周期：编辑、保存
    handleSettlementPeriodTypeTitleCLick() {
      this.$refs.signalBaseInfoForm.validateField(
        "settlementPeriodType",
        (errorMessage) => {
          if (!errorMessage) {
            this.$axios
              .post("/api/Portfolio/InitShareProfitPeriod", {
                id: this.checkPortfolio.id,
                settlementPeriodType: +this.formVal.settlementPeriodType,
              })
              .then((res) => {
                let dt = res.data;
                if (dt.isSuccess) {
                  this.$notify.success({
                    title: this.$t("Common_Prompt"),
                    message: this.$t("Common_OperateSuccess"),
                  });
                  this.getBaseInfo();
                } else {
                  this.$notify.error({
                    title: this.$t("Common_Prompt"),
                    message: dt.result,
                  });
                }
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        }
      );
    },
    cancelSignal() {
      this.isDisabledDialog = false;
    },
    settleUnbind() {
      const loading = this.$loading({
        lock: true,
      });
      this.$axios
        .get(
          "/Api/Portfolio/SettltementPortfolioDetail?id=" +
            this.checkPortfolio.id
        )
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.isDisabledDialog = true;
            this.settleUnbindForm = dt.result;
            this.settleUnbindForm.shareTotalProfit = formatNumberFractionDigits(
              this.settleUnbindForm.shareTotalProfit
            );
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    settleUnbindSubmit() {
      this.$confirm(
        this.$t("SignalSource_SettleUnbindConfirmPrompt"),
        this.$t("Common_Prompt"),
        {
          confirmButtonText: this.$t("Common_Confirm"),
          cancelButtonText: this.$t("Common_Cancel"),
          type: "warning",
        }
      ).then(() => {
        const loading = this.$loading({
          lock: true,
        });
        this.$axios
          .get(
            "/Api/Portfolio/SettltementPortfolio?id=" + this.checkPortfolio.id
          )
          .then((res) => {
            let dt = res.data;
            if (dt.isSuccess) {
              this.$notify.success({
                title: this.$t("Common_Prompt"),
                message: this.$t("Common_OperateSuccess"),
              });
              //this.getBaseInfo();
              this.isDisabledDialog = false;
              this.$router.push({ path: "/MySignal" });
            } else {
              this.$notify.error({
                title: this.$t("Common_Prompt"),
                message: dt.result,
              });
            }
          })
          .finally(() => {
            loading.close();
          });
      });
    },
    // 打开重新登录弹窗
    handleReRegister() {
      this.visibleReregister = true;
    },
    // 取消重新登录
    cancelReregister() {
      this.visibleReregister = false;
    },
    // 重新登录弹窗确认
    handleReregisterSubmit() {
      this.$refs.reregisterForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
          });
          this.$axios
            .post("/api/Portfolio/ReLogin", {
              signalId: this.checkPortfolio.id,
              password: this.reregisterFormVal.password,
            })
            .then((res) => {
              let dt = res.data;
              if (dt.isSuccess) {
                this.$notify.success({
                  title: this.$t("Common_Prompt"),
                  message: this.$t("Common_OperateSuccess"),
                });
                this.getBaseInfo();
                this.visibleReregister = false;
              } else {
                this.$notify.error({
                  title: this.$t("Common_Prompt"),
                  message: dt.result,
                });
              }
            })
            .finally(() => {
              loading.close();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },

  render() {
    const billingCycleOptions = [
      { label: this.$t("Common_Week"), value: 2 },
      { label: this.$t("Common_Month"), value: 3 },
      { label: this.$t("Common_Quarter"), value: 4 },
      { label: this.$t("Common_HalfAYear"), value: 5 },
    ];

    const colSpan = isMobile ? 24 : 12;

    return (
      <div class={{ tableDiv: !isMobile, [styles.h5Container]: isMobile }}>
        <Form
          ref="signalBaseInfoForm"
          labelPosition="top"
          props={{ model: this.formVal }}
          class={styles.signalBaseInfoForm}
        >
          {/* --------------------------信号设置-------------------------- */}
          <div class={styles.formGroupTitle}>
            <div class={styles.diamondIcon} />
            {this.$t("SignalSource_SignalSetting")}
          </div>
          <Row gutter={30}>
            {/* 名称 */}
            <Col span={colSpan}>
              <FormItem label={this.$t("Common_TableTitle_SignalSource")} prop="portfolioName">
                <Input v-model={this.formVal.portfolioName} disabled />
              </FormItem>
            </Col>
            {/* 分润比例 */}
            <Col span={colSpan}>
              <FormItem
                label={this.$t("Common_TableTitle_SignalPLSharingRatio")}
                prop="shareProfitPercent"
                rules={{
                  validator: (_, value, callback) => {
                    if (!`${value}`) {
                      return callback(
                        new Error(this.$t("Common_valid_CheckSignalSharingRatio"))
                      );
                    } else {
                      var reg = /^([0]$)|(^[1-9][0-9]{0,1}|100)$/;
                      if (!reg.test(value)) {
                        callback(new Error(this.$t("Common_Valid_CheckInt100")));
                      } else {
                        callback();
                      }
                    }
                  },
                }}
              >
                <div class={styles.editFormItemWrapper}>
                  <Input
                    v-model={this.formVal.shareProfitPercent}
                    disabled={this.shareProfitPercentStatus == 1}
                    placeholder="0-100"
                  >
                    <template slot="suffix">%</template>
                  </Input>
                  {!this.shareProfitPercentStatus && (
                    <Button
                      type="text"
                      class={styles.editButton}
                      onClick={this.handleShareProfitPercentCLick}
                    >
                      {this.shareProfitPercentStatus
                        ? this.$t("Common_Operation_Edit")
                        : this.$t("Common_Save")}
                    </Button>
                  )}
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={30}>
            {/* 结算周期 */}
            <Col span={colSpan}>
              <FormItem
                prop="settlementPeriodType"
                rules={{
                  required: true,
                  message: this.$t("Common_valid_CheckSettlementPeriod"),
                }}
                class={styles.billingCycleFormItem}
              >
                <div slot="label" class={styles.billingCycleLabel}>
                  <span>{this.$t("Common_TableTitle_SignalSettlementCycle")}</span>
                  <Tooltip
                    content={this.$t("SignalSource_BasedOnCalendarDays")}
                    placement="right"
                  >
                    <svg-icon class="labelIcon" icon-class="LabelIcon" />
                  </Tooltip>
                </div>
                <div class={styles.editFormItemWrapper}>
                  <Select
                    v-model={this.formVal.settlementPeriodType}
                    disabled={this.settlementPeriodTypeStatus == 1}
                  >
                    {billingCycleOptions.map((itemOption) => (
                      <Option
                        key={itemOption.value}
                        label={itemOption.label}
                        value={itemOption.value}
                      />
                    ))}
                  </Select>
                  {!this.settlementPeriodTypeStatus && (
                    <Button
                      type="text"
                      class={styles.editButton}
                      onClick={this.handleSettlementPeriodTypeTitleCLick}
                    >
                      {this.settlementPeriodTypeStatus
                        ? this.$t("Common_Operation_Edit")
                        : this.$t("Common_Save")}
                    </Button>
                  )}
                </div>
              </FormItem>
            </Col>
            {/* 跟单方向 */}
            <Col span={colSpan}>
              <FormItem
                label={this.$t("Common_TableTitle_CopyDirection")}
                prop="followDirection"
              >
                <Input v-model={this.formVal.followDirection} disabled />
              </FormItem>
            </Col>
          </Row>
          <Row gutter={30}>
            {/* 创建时间 */}
            <Col span={colSpan}>
              <FormItem label={this.$t("Common_TableTitle_CreateTime")} prop="createTime">
                <Input v-model={this.formVal.createTime} disabled />
              </FormItem>
            </Col>
            {/* 本期开始时间 */}
            <Col span={colSpan}>
              <FormItem
                label={this.$t("Common_TableTitle_CurrentBeginTime")}
                prop="currentSettlementBeginTime"
              >
                <Input
                  v-model={this.formVal.currentSettlementBeginTime}
                  disabled
                />
              </FormItem>
            </Col>
          </Row>
          <Row gutter={30}>
            {/* 本期结算时间 */}
            <Col span={colSpan}>
              <FormItem
                label={this.$t("Common_TableTitle_CurrentEndTime")}
                prop="currentSettlementEndTime"
              >
                <Input
                  v-model={this.formVal.currentSettlementEndTime}
                  disabled
                />
              </FormItem>
            </Col>

            {/* 启用状态 */}
            <Col span={colSpan}>
              <FormItem label={this.$t("Common_TableTitle_Status")}>
                <div class={styles.editFormItemWrapper}>
                  <Input v-model={this.enableStatusTxt} disabled />
                  {!!this.enableStatus && (
                    <Button
                      type="text"
                      class={styles.editButton}
                      onClick={this.settleUnbind}
                    >
                      {this.$t("Common_Operation_SettleAndDisabled")}
                    </Button>
                  )}
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={30}>
            {/* 禁用时间 */}
            {!this.enableStatus && (
              <Col span={colSpan}>
                <FormItem label={this.$t("Common_TableTitle_DisabledTime")} prop="updateTime">
                  <Input v-model={this.formVal.updateTime} disabled />
                </FormItem>
              </Col>
            )}
          </Row>
          {/* 分割线 */}
          <div class={styles.dividerLine} />
          {/* --------------------------信号账号-------------------------- */}
          <div class={styles.formGroupTitle}>
            <div class={styles.diamondIcon} />
            {this.$t("Common_TableTitle_SignalAccount")}
          </div>
          <Row gutter={30}>
            {/* 信号账户 */}
            <Col span={colSpan}>
              <FormItem
                label={this.$t("Common_TableTitle_Mt4Account")}
                prop="account"
              >
                <Input v-model={this.formVal.account} disabled />
              </FormItem>
            </Col>
            {/* 服务器 */}
            <Col span={colSpan}>
              <FormItem label={this.$t("Common_Mt4Server")} prop="serverName">
                <Input v-model={this.formVal.serverName} disabled />
              </FormItem>
            </Col>
          </Row>
          <Row gutter={30}>
            {/* 净值 */}
            <Col span={colSpan}>
              <FormItem label={this.$t("Common_TableTitle_Equity")} prop="equity">
                <Input v-model={this.formVal.equity} disabled />
              </FormItem>
            </Col>
            {/* 余额 */}
            <Col span={colSpan}>
              <FormItem label={this.$t("Common_TableTitle_Balance")} prop="balance">
                <Input v-model={this.formVal.balance} disabled />
              </FormItem>
            </Col>
          </Row>
          <Row gutter={30}>
            {/* 盈亏 */}
            <Col span={colSpan}>
              <FormItem label={this.$t("Common_TableTitle_CurrentProfitLoss")} prop="profit">
                <Input
                  v-model={this.formVal.profit}
                  disabled
                  class={[
                    this.formVal.profit > 0
                      ? "greenNum"
                      : this.formVal.profit < 0
                      ? "redNum"
                      : "",
                    "mobileTableContent",
                  ]}
                />
              </FormItem>
            </Col>
            {/* 连接状态 */}
            <Col span={colSpan}>
              <FormItem label={this.$t("Common_ConnectionStatus")} prop="loginStatus">
                <div class={styles.editFormItemWrapper}>
                  <Input
                    value={
                      this.formVal.loginStatus === 0
                        ? this.$t("Common_ConnectionSuccess")
                        : this.$t("Common_ConnectionFail")
                    }
                    disabled
                    class={
                      this.formVal.loginStatus === 0 ? "greenNum" : "redNum"
                    }
                  />
                  {this.formVal.loginStatus !== 0 && (
                    <Button
                      type="text"
                      class={styles.editButton}
                      onClick={this.handleReRegister}
                    >
                      {this.$t("Common_Operate_ReRegister")}
                    </Button>
                  )}
                </div>
              </FormItem>
            </Col>
          </Row>
        </Form>
        <Dialog
          title={this.$t("Common_Operate_ReRegister")}
          visible={this.visibleReregister}
          close-on-click-modal={false}
          width="40%"
          top="20vh"
          onClose={this.cancelReregister}
        >
          <Form
            ref="reregisterForm"
            labelPosition={isMobile ? "top" : "left"}
            props={{ model: this.reregisterFormVal }}
            class={styles.signalBaseInfoForm}
            label-width="150px"
          >
            {/* 账户 */}
            <FormItem label={this.$t("Common_Mt4Account")} prop="account">
              <Input v-model={this.reregisterFormVal.account} disabled />
            </FormItem>
            {/* 服务器 */}
            <FormItem label={this.$t("Common_Mt4Server")} prop="serverName">
              <Input v-model={this.reregisterFormVal.serverName} disabled />
            </FormItem>
            {/* 交易密码 */}
            <FormItem
              label={this.$t("Common_Mt4AccountPassword")}
              prop="password"
              rules={{
                required: true,
                message: this.$t("Common_Valid_CheckMt4AccountPassword"),
              }}
            >
              <Input
                v-model={this.reregisterFormVal.password}
                type={this.reregisterPasswordVisible ? "text" : "password"}
              >
                <template slot="suffix">
                  <i
                    class="el-icon-view"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.reregisterPasswordVisible = !this.reregisterPasswordVisible;
                    }}
                  />
                </template>
              </Input>
            </FormItem>
          </Form>
          <div slot="footer" class="dialog-footer">
            <Button
              class="confirmDialogBtn"
              onClick={this.handleReregisterSubmit}
            >
              {this.$t("Common_Confirm")}
            </Button>
          </div>
        </Dialog>
        <Dialog
          title={this.$t("Common_Operation_SettleAndDisabled")}
          visible={this.isDisabledDialog}
          close-on-click-modal={false}
          width="40%"
          top="5vh"
          onClose={this.cancelSignal}
        >
          <Form
            ref="settleUnbindForm"
            labelPosition={isMobile ? "top" : "left"}
            props={{ model: this.settleUnbindForm }}
            class={styles.signalBaseInfoForm}
            label-width="150px"
          >
            {/* 本期开始时间 */}
            <FormItem
              label={this.$t("Common_TableTitle_CurrentBeginTime")}
              prop="currentBeginTime"
            >
              <Input
                v-model={this.settleUnbindForm.currentBeginTime}
                disabled
              />
            </FormItem>
            {/* 跟随客户 */}
            <FormItem label={this.$t("Common_TableTitle_FollowCustomers")} prop="followUserCount">
              <Input v-model={this.settleUnbindForm.followUserCount} disabled />
            </FormItem>
            {/* 分润比例 */}

            <FormItem label={this.$t("Common_TableTitle_SignalPLSharingRatio")} prop="sharePercent">
              <Input v-model={this.settleUnbindForm.sharePercent} disabled />
              <p class={styles.sharePercentIcon}>%</p>
            </FormItem>
            {/* 分润金额 */}
            <FormItem label={this.$t("Common_TableTitle_PaymentProfitMoney")} prop="shareTotalProfit">
              <Input
                v-model={this.settleUnbindForm.shareTotalProfit}
                disabled
              />
            </FormItem>
          </Form>
          {this.settleUnbindForm.settlementStatus == 1 && (
            <p class={styles.settleUnbindTips}>{this.$t("SignalSource_CannotSettleUnbindTips")}</p>
          )}
          {this.settleUnbindForm.settlementStatus !== 1 && (
            <div slot="footer" class="dialog-footer">
              <Button
                class="confirmDialogBtn"
                onClick={this.settleUnbindSubmit}
              >
                {this.$t("Common_Confirm")}
              </Button>
            </div>
          )}
        </Dialog>
      </div>
    );
  },
};

export default SignalBaseInfo;
